import type { WorkLocationResponse } from '../types';
import { stateName } from './usStateNames';

/** The warning under an Active location whose registration is not complete. It says only what is on file: nothing is claimed as filed, verified or ready. */
export function registrationWarning(location: WorkLocationResponse): string | null {
  if (location.status !== 'Active' || location.registrationComplete) return null;
  const where = stateName(location.state);
  switch (location.taxRegistrationStatus) {
    case 'InProgress':
      return `Payroll Tax Registration is still in progress. This location is in ${where} and is not complete until its payroll tax account details are on file.`;
    case 'NotRequired':
      return `Payroll Tax Registration is marked not required for ${where}. This stays incomplete until an authorized person verifies the exemption.`;
    case 'Registered':
      return `Payroll Tax Registration is missing details. ${location.registrationIssues[0] ?? ''}`.trim();
    default:
      return `Payroll Tax Registration not completed. This location is in ${where} but has no payroll tax account on file.`;
  }
}

